const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const moment = require("moment");
const {BookText} = require("lucide-react");
const AT = require("src/core/vault/ActionTypes");

const withAnimateScroll = require("src/core/hoc/withAnimateScroll");
const withVaultDispatch = require("src/core/hoc/withVaultDispatch");
const withVaultUpdate = require("src/core/hoc/withVaultUpdate");
const withContainerDims = require("src/core/hoc/withContainerDims");
const withOfficeErrorCatching = require("src/core/hoc/withOfficeErrorCatching");
const {getBaseInstance} = require("src/core/util/HOCUtil");

const Slots = require("src/core/vault/Slots");
const {atParentAccount} = require("src/core/vault/StateCursors");
const LoadGuard = require("src/core/view/LoadGuard");
const Link = require("src/core/view/Link");
const URLMake = require("shared/URLMake");
const LoadingCircle = require("src/core/view/LoadingCircle");
const StudentStats = require("./StudentStats");
const ParentUtil = require("src/parent/util/ParentUtil");
const ReportProblems = require("src/school/ReportProblems");
const OfficeModal = require("src/office/modals/OfficeModal");
const AvatarLinkGroup = require("./AvatarLinkGroup");
const AssetsUtil = require("src/core/util/AssetsUtil");
const PrivacyBanner = require("src/core/view/PrivacyBanner");
const OpsUser = require("src/core/vault/OpsUser");

const styles = require("./styles/PageParent.css");
const CopyTable = require("src/office/data/CopyTable");
const {track} = require("src/core/util/Mixpanel");
const {STUDENT_REGISTRATION_EVENTS} = require("shared/events/registration");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withAnimateScroll(Component);
	Component = withVaultDispatch(Component);
	Component = withContainerDims(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => ({
			parentData: Slots.getValue(vaultState, Slots.table.parentData()),
			deferrals: atParentAccount(vaultState).getIn("deferrals"),
		}),
		{forLoggedIn: true}
	);
	Component = withOfficeErrorCatching(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "PageParent",

		propTypes: {
			user: PT.object.isRequired,
			scrollStudentID: PT.number,
			setNextScrollTo: PT.func.isRequired,

			// Injected by HOCs
			parentData: PT.object.isRequired,
			deferrals: PT.array, // null until loaded
			dispatch: PT.func.isRequired,
			containerDims: PT.shape({
				windowWidth: PT.number,
			}).isRequired,
			animateScroll: PT.func.isRequired,
		},

		getInitialState: function() {
			if (_.get(this.props.parentData, "needsDataReload", false)) {
				this.props.dispatch({type: AT.PARENT_OFFICE_STUDENT_DATA_RELOAD});
			}
			return {
				filters: {},
				reactCrashed: false,
				showProblemModal: false,
				showProblemProps: null,
				parentTutorialStep: null,
			};
		},

		vaultEvents: {
			showReportProblemModal: function(eventProps) {
				const student = this.props.parentData.students[eventProps.userID];
				this.setState({
					showProblemModal: true,
					showProblemProps: {
						...eventProps,
						inActiveClasses: student?.inActiveClasses,
					},
				});
			},
			showParentTutorial: function(eventProps) {
				this.setState({
					parentTutorialStep: eventProps.step,
				});
			},
		},

		// Scroll on mount, if possible (if everything already loaded)
		// Also add scroll listener for tutorial arrow hiding purposes.
		componentDidMount: function() {
			this.props.dispatch({type: AT.LOAD_BOOK_DEFERRALS_REQUEST});
			if (this.props.scrollStudentID && this.scrollStudentContainer) {
				this.props.setNextScrollTo(this.scrollStudentContainer);
			}
			window.addEventListener("scroll", this.handleScroll);
		},

		// Remove scroll listener
		componentWillUnmount: function() {
			window.removeEventListener("scroll", this.handleScroll);
		},

		handleScroll: function(event) {
			if (this.state.parentTutorialStep === "supportMenu") {
				if (
					document.body.scrollTop > 50 ||
					document.documentElement.scrollTop > 50
				) {
					this.setState({hideArrows: true});
				} else {
					this.setState({hideArrows: false});
				}
			}
		},

		// If things just loaded, then scroll.
		// Or if a new student id is specified to be scrolled to.
		// Also scrolls to top for support menu parent tutorial.
		componentDidUpdate: function(prevProps, prevState) {
			if (
				this.props.parentData.load === "done" &&
				prevProps.parentData.load !== "done"
			) {
				this.props.setNextScrollTo(this.scrollStudentContainer);
			} else if (
				this.props.scrollStudentID &&
				this.props.scrollStudentID !== prevProps.scrollStudentID
			) {
				this.props.setNextScrollTo(this.scrollStudentContainer);
			} else if (
				this.state.parentTutorialStep !== prevState.parentTutorialStep &&
				this.state.parentTutorialStep === "supportMenu"
			) {
				this.props.animateScroll();
			}
		},

		onProblemModalClose: function() {
			this.setState({
				showProblemModal: false,
				showProblemProps: null,
			});
		},

		onTutorialClose: function() {
			if (this.state.parentTutorialStep === "registrationSuccess") {
				const newState = {parentTutorialStep: "supportMenu"};
				const doc = document.documentElement;
				if ((window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0) > 0) {
					newState.hideArrows = true;
				}
				track(STUDENT_REGISTRATION_EVENTS.TUTORIAL_MODAL_CLOSE);
				this.setState(newState);
			} else if (this.state.parentTutorialStep === "supportMenu") {
				track(STUDENT_REGISTRATION_EVENTS.SUPPORT_MODAL_CLOSE);
				this.setState({parentTutorialStep: null});
			} else {
				this.setState({parentTutorialStep: null});
			}
		},

		openResult: function({resultID, problemIndex, blockID, userID, isTrophy}) {
			if (resultID || blockID) {
				this.props.dispatch({
					type: AT.SHOW_REPORT_PROBLEM_MODAL,
					resultID,
					problemIndex,
					blockID,
					userID,
					isTrophy,
				});
			}
		},

		renderTermsAndConditions: function() {
			if (!OpsUser.hasAcceptedTerms(this.props.user)) {
				return <PrivacyBanner pageType="report" />;
			}
			return;
		},

		renderDeferralWarning: function() {
			const deferrals = this.props.deferrals;
			if (!deferrals || !deferrals.length) return null;

			let message;
			// if there are multiple deferrals, we will show the expiration of the first deferral
			// deferrals are sorted by soonest expiration date so we can assume the first deferral is the soonest
			if (deferrals.length >= 1) {
				const deferral = deferrals[0];
				const expiresAt = moment(deferral.expiresAt).format("MMM D, h:mma");
				message = (
					<span>
						{`Confirm or update your book level by `}
						<strong>{expiresAt}</strong>
						{" to complete your order. "}
					</span>
				);
			}

			return (
				<div className={styles.deferralWarning}>
					<div className={styles.deferralWarningMain}>
						<BookText className={styles.deferralWarningIcon} />
						<div className={styles.deferralWarningText}>{message}</div>
					</div>
					<Link
						className={styles.deferralWarningButton}
						to={URLMake.forAccount("subscriptions")}
					>
						{"Confirm book level"}
					</Link>
				</div>
			);
		},

		renderLoadedParent: function() {
			const {parentData, user} = this.props;
			const studentsData = ParentUtil.getStudentsWithActivity(parentData);
			const fitAvatars = ParentUtil.fitAvatars(this.props);

			let ordered = _.map(studentsData, (studentData, sid) => {
				studentData.id = parseInt(sid);
				return studentData;
			});
			ordered = _.sortBy(ordered, ["displayName"]);
			const orderedInactive = _.filter(ordered, o => !o.isActive);
			const orderedActive = _.filter(ordered, o => o.isActive);

			const studentDivs = _.concat(orderedActive, orderedInactive).map(
				(studentData, i) => {
					const recentData = studentData.activity.recent;
					const twoWeekStats = ParentUtil.computeRecentStats(recentData, 14);

					let refFunction = null;
					if (studentData.id === this.props.scrollStudentID) {
						refFunction = ss => {
							this.scrollStudentContainer = ss && getBaseInstance(ss).getRef();
						};
					}

					return (
						<StudentStats
							key={studentData.id}
							studentID={studentData.id}
							studentData={studentData}
							recentData={recentData}
							twoWeekStats={twoWeekStats}
							ref={refFunction}
							openResult={this.openResult}
						/>
					);
				}
			);

			let headerClass = styles.headerContentFit;
			let linkClass = styles.studentLinksFit;
			if (fitAvatars) {
				headerClass = styles.headerContent;
				linkClass = styles.studentLinks;
			}

			let tutorialModal;
			if (this.state.parentTutorialStep) {
				const step = this.state.parentTutorialStep;
				const registeredStudent = _.find(
					_.values(studentsData),
					student => student.hasRegistered
				);
				const copy = CopyTable.getParentTutorialModal(
					styles,
					registeredStudent.displayName
				)[step];
				let arrowStyle = styles.arrow;
				let mobileArrowStyle = styles.arrowMobile;
				if (this.state.hideArrows) {
					arrowStyle += " " + styles.hideArrow;
					mobileArrowStyle += " " + styles.hideArrow;
				}
				tutorialModal = (
					<OfficeModal
						modalClass={styles[step]}
						closeClass={styles.modalClose}
						onClose={this.onTutorialClose}
						closeOnEsc={true}
						portalContainer={null}
						level="overBar"
						closeOnBackdropClick={true}
						isScrollable={false}
						isFixed={false}
					>
						<div className={styles.parentTutorialContainer}>
							<div className={styles.aboveButton}>
								<div className={styles.parentTutorialTitle}>{copy.title}</div>
								{copy.contents}
							</div>
							<div className={styles.button} onClick={this.onTutorialClose}>
								{copy.buttonText}
							</div>
						</div>
						<div className={mobileArrowStyle}>
							<img src={AssetsUtil.getParentTutorialImage("arrow-curved")} />
						</div>
						<div className={arrowStyle}>
							<img src={AssetsUtil.getParentTutorialImage("arrow-straight")} />
						</div>
					</OfficeModal>
				);
			}

			const problemModal = this.state.showProblemModal ? (
				<OfficeModal
					modalClass={styles.problemsModal}
					backdropWrapperClass={styles.problemsBackdropWrapper}
					backdropClass={styles.problemsBackdrop}
					closeClass={styles.modalClose}
					closeColor="white"
					onClose={this.onProblemModalClose}
					closeOnEsc={true}
					gateway={null}
					level="overBar"
					closeOnBackdropClick={true}
					isScrollable={true}
					isFixed={true}
				>
					<ReportProblems
						user={user}
						forParent={true}
						{...this.state.showProblemProps}
					/>
				</OfficeModal>
			) : null;

			let studentClass = styles.studentsContainer;
			if (!OpsUser.hasAcceptedTerms(this.props.user)) {
				studentClass += " " + styles.disabled;
			}

			return (
				<div className={styles.mainInner}>
					<div className={styles.header}>
						<div className={headerClass}>
							<div className={styles.title}>
								<span>Reports</span>
							</div>
							<AvatarLinkGroup
								key="avatarlinkgroup"
								className={linkClass}
								studentsData={studentsData}
								selectedID={0}
								extraAvatar={{
									imgSrc: AssetsUtil.getBeastAvatar("team"),
									label: "All Students",
								}}
								isCentered={!fitAvatars}
							/>
						</div>
					</div>
					<div className={styles.content}>
						{this.renderDeferralWarning()}
						<div className={studentClass}>{studentDivs}</div>
					</div>
					{problemModal}
					{tutorialModal}
				</div>
			);
		},

		render: function() {
			const requestLoad = () =>
				this.props.dispatch({
					type: AT.LOAD_PARENT_DATA_SLOT_REQUEST,
				});

			// Loading inside the parent page instead of on entire page.
			const loadingView = (
				<div className={styles.loadingOuter}>
					<div className={styles.loading}>
						<LoadingCircle colorType="color" />
					</div>
				</div>
			);

			const slotLoadGuard = (
				<LoadGuard
					identifier="officeParent"
					status={this.props.parentData}
					requestLoad={requestLoad}
					loadingView={loadingView}
					errorView="refreshOffice"
					renderLoaded={this.renderLoadedParent}
				/>
			);

			return (
				<div className={styles.main}>
					{this.renderTermsAndConditions()}
					{slotLoadGuard}
				</div>
			);
		},
	})
);
